const DEFAULT_SITE_URL = "https://scamatrix.com";

function normalizeSiteUrl(value: string): string {
    const trimmed = value?.trim();
    if (!trimmed) {
        return DEFAULT_SITE_URL;
    }

    const withProtocol = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`;

    try {
        const url = new URL(withProtocol);
        url.protocol = "https:";
        if (url.hostname.startsWith("www.")) {
            url.hostname = url.hostname.replace(/^www\./, "");
        }
        return url.origin;
    } catch {
        return DEFAULT_SITE_URL;
    }
}

export const baseURL = normalizeSiteUrl(process.env.SITE_URL ?? process.env.NEXT_PUBLIC_SITE_URL ?? DEFAULT_SITE_URL);
